import moment from "moment/moment";

export default function MainDetails({ wilaya, number, date }) {
  return (
    <>
      <div className="block sm:flex justify-between">
        <section className="hidden sm:flex flex-col items-start justify-start">
          {/* <h2 className="font-light text-sm uppercase mb-1">page</h2> */}
        </section>
        <section className="flex flex-col sm:ml-24 items-center justify-center">
          <h2 className="font-bold text-xl uppercase mb-1 text-center">
            Facture Proforma N° {number}
          </h2>
        </section>
        <section className="flex flex-col items-end justify-end">
          <p className="font-normal text-sm mb-1">
            {wilaya}, Le: {moment(date).format("DD/MM/YYYY")}
          </p>
        </section>
      </div>
      <br />
      <hr className="border-b-2 border-primary-color" />
    </>
  );
}
